<template>
  <v-menu
    min-width="450"
    max-width="450"
    max-height="600"
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon small v-bind="attrs" v-on="on" @click="getVersionFromDate">
        <v-icon color="grey">
          visibility
        </v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item v-for="version in versions" :key="version.id">
        <DocumentBlockMiniViewer
          :value="version"
          btn-title="Застосувати"
          @add="$emit('apply', version.id)"
          @get-items="getDocumentsByBlock(version.id)"
        />
      </v-list-item>
    </v-list>
    <div class="text-center">
      <DialogItemsList
        v-model="dialog"
        :items="documents"
        :loading="loading"
        header="Список документів"
        @close="dialog = false"
      />
    </div>
  </v-menu>
</template>

<script>
import DocumentBlockMiniViewer from "./DocumentBlockMiniViewer.vue";
import DialogItemsList from "../../components/DialogItemsList.vue";
import { getDocumentBlockVersions } from "../../backend/document-blocksApi.js";
import { getDocumentsByBlock } from "../../backend/documentsApi.js";

export default {
  components: {
    DocumentBlockMiniViewer,
    DialogItemsList,
  },
  props: ["value"],
  data: () => {
    return {
      versions: [],
      loading: false,
      documents: [],
      dialog: false,
    };
  },
  methods: {
    async getVersionFromDate() {
      this.versions = await getDocumentBlockVersions(
        this.value.id,
        this.value.confirmationDate
      );
    },
    async getDocumentsByBlock(blockId) {
      this.dialog = true;
      this.loading = true;
      this.documents = [];
      this.documents = await getDocumentsByBlock(blockId);
      this.loading = false;
    },
  },
};
</script>
